import React from 'react';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';
import { getMediaProvider, isGoogleDriveThumbnailUrl, normalizeMediaUrl } from '../Utils/mediaUrls';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];
const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.webm', '.m4v'];

const getMediaUrl = (media) => (typeof media === 'string' ? media : media?.url || media?.src || media?.viewUrl);

const getPathname = (url) => {
  try {
    return new URL(url).pathname.toLowerCase();
  } catch (error) {
    return String(url || '').toLowerCase();
  }
};

const hasExtension = (url, extensions) => {
  const pathname = getPathname(url);

  return extensions.some((extension) => pathname.endsWith(extension));
};

const getMediaType = (media) => {
  if (!media || typeof media === 'string') {
    return '';
  }

  return String(media.mediaType || media.type || media.contentType || media.mimeType || '').toLowerCase();
};

const Lightbox = ({ media, onClose }) => {
  const mediaUrl = getMediaUrl(media);
  const isGoogleDrive = getMediaProvider(mediaUrl) === 'google-drive';
  const mediaType = getMediaType(media);
  const isVideo = mediaType.includes('video') || hasExtension(mediaUrl, VIDEO_EXTENSIONS);
  const isImage = mediaType.includes('image') || isGoogleDriveThumbnailUrl(mediaUrl) || hasExtension(mediaUrl, IMAGE_EXTENSIONS) || (isGoogleDrive && !isVideo);

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 3000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          width: '90%',
          maxWidth: '800px',
          height: '80%',
          maxHeight: '600px',
          margin: 'auto',
          border: 'none',
          background: '#fff',
          position: 'relative',
          padding: '0',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }
      }}
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {isVideo ? (
          isGoogleDrive ? (
            <iframe
              src={normalizeMediaUrl(mediaUrl, 'preview')}
              title="Media preview"
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '10px' }}
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <ReactPlayer
              url={mediaUrl}
              controls
              width="100%"
              height="100%"
              style={{ borderRadius: '10px' }}
            />
          )
        ) : isImage ? (
          <img
            src={normalizeMediaUrl(mediaUrl, 'image')}
            alt="lightbox"
            style={{ width: '100%', height: 'auto', maxHeight: '100%', objectFit: 'contain', borderRadius: '10px' }}
          />
        ) : (
          <p style={{ color: '#333', textAlign: 'center', padding: '20px' }}>Unsupported media type</p>
        )}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            fontSize: '1.5rem',
            color: '#333',
            background: '#fff',
            border: '2px solid #333',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '0',
            zIndex: 1,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
          }}
        >
          X
        </button>
      </div>
    </Modal>
  );
};

export default Lightbox;
